import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';

export const HttpLanguageInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const locale = inject(LOCALE_ID);

    if (!request.headers.get('Accept-Language')) {
        request = request.clone({
            headers: request.headers.append('Accept-Language', locale),
        });
    }
    return next(request);
};
